<template>
<div :style="{ 'padding': `${data.DividerUp ? data.DividerUp : 0}px ${data.DividerRight ? data.DividerRight : 15}px ${data.DividerDown ? data.DividerDown : 0}px ${data.DividerLeft ? data.DividerLeft : 15}px ` }">
  <v-divider
    :dark="data.DividerDark ? true : false"
  />
</div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
  }
</script>
